import { initPlasmicLoader } from "@plasmicapp/loader-react";
import { IS_PRODUCTION, PLASMIC_ID, PLASMIC_TOKEN } from "utils/constants";
export const PLASMIC = initPlasmicLoader({
  projects: [
    {
      id: PLASMIC_ID, // ID of a project you are using
      token: PLASMIC_TOKEN // API token for that project
    }
  ],
  // Fetches the latest revisions, whether or not they were unpublished!
  // Disable for production to ensure you render only published changes.
  preview: !IS_PRODUCTION
});
